module.exports = __webpack_public_path__ + "media/audio10.dbf3ad18.mp4";